import React, { Fragment } from "react";
import { Button, Grid } from "@material-ui/core";
import { ViewModule, List } from "@material-ui/icons";
import ActiveDealsList from "./Active/List";
import PipelineAndDeadTiles from "./PipelineAndDeadTiles";
import TablePaginationHelper from "utils/tablePaginationHelper";

class ActiveDeals extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      view: "list"
    };

    this.tablePaginationHelper = new TablePaginationHelper("28cb3260-f045-4439-87ba-3e39c5e05a9b", 25);
  }

  listView = () => {
    this.setState({ view: "list" });
  };

  tileView = () => {
    this.setState({ view: "tile" });
  };

  updatePage = (page) => {
    this.tablePaginationHelper.page = page;
  }

  render() {
    return (
      <Fragment>
        <Grid xs={12} item style={{ marginTop: 4 }}>
        {this.state.view === "list" ? (
            <ActiveDealsList
              {...this.props}
              rowsPerPage={this.tablePaginationHelper.rowsPerPage}
              page={this.tablePaginationHelper.page}
              updateRowsPerPage={this.updateRowsPerPage}
              updatePage={this.updatePage}
            />
          ) : (
            <PipelineAndDeadTiles {...this.props} />
          )}
          <Button
            className="button_tableGridChanger _List"
            onClick={this.listView}
          >
            <List />
          </Button>
          <Button
            className="button_tableGridChanger _Block"
            onClick={this.tileView}
          >
            <ViewModule />
          </Button>
        </Grid>
        
      </Fragment>
    );
  }
}

export default ActiveDeals;
